import { KeyValue } from '@/main/models/common';
import { BodyShopFilterRequest } from '@/main/models/request/bodyshopRequest';

export enum BodyshopBranchTypes {
  GET_BODYSHOP_BRANCHES = '@bodyshopBranch/GET_BODYSHOP_BRANCHES',
  SAVE_BODYSHOP_BRANCHES = '@bodyshopBranch/SAVE_BODYSHOP_BRANCHES',
  RESET_REDUCER_BODYSHOP_BRANCHES = '@bodyshopBranch/RESET_REDUCER_BODYSHOP_BRANCHES'
}

export interface BodyshopBranchState {
  readonly bodyshopBranches: {
    data: KeyValue[] | null;
    errorMessages: string[] | null;
    isError: boolean;
    isLoading: boolean;
  };
}

export interface GetBodyshopBranches {
  type: typeof BodyshopBranchTypes.GET_BODYSHOP_BRANCHES;
  payload: {
    request: BodyShopFilterRequest;
  };
}

export interface SaveBodyshopBranches {
  type: typeof BodyshopBranchTypes.SAVE_BODYSHOP_BRANCHES;
  payload: {
    data: KeyValue[] | null;
    isError: boolean;
    errorMessages: string[] | null;
  };
}

export interface ResetReducerBodyshopBranches {
  type: typeof BodyshopBranchTypes.RESET_REDUCER_BODYSHOP_BRANCHES;
}

export type BodyshopBranchActionTypes =
  | GetBodyshopBranches
  | SaveBodyshopBranches
  | ResetReducerBodyshopBranches;
